import React from 'react';
import { FormattedMessage } from "react-intl";
import './LinkKopieren.css';

// Darstellung des "Link kopieren"-Buttons. Das Info-Symbol ("i") sitzt direkt
// rechts neben dem Text INNERHALB des Buttons; der Button bleibt eine
// zusammengehoerige Klickflaeche. Reine Praesentation: das eigentliche Kopieren
// und die Link-Erzeugung passieren unveraendert im onCopy-Handler der
// zustandsfuehrenden Eltern-Komponente.
//
// status: "" (Standard) | "success" (Button-Text wechselt fuer 2 s auf
//         "Link kopiert") | "error" (kurze Fehlermeldung neben dem Button)
function LinkKopieren({ onCopy, status }) {
    return (
        <div className="link-kopieren">
            <button type="button" className="download link-kopieren-button" onClick={onCopy}>
                <span className="link-kopieren-text">
                    <FormattedMessage id={status === "success" ? "Link_kopiert" : "Link_kopieren"} />
                </span>
                <span className="link-kopieren-info" aria-hidden="true">
                    i
                    <span className="link-kopieren-tooltip" role="tooltip">
                        <FormattedMessage id="Link_kopieren_Hilfe" />
                    </span>
                </span>
            </button>
            {status === "error" && (
                <span className="link-kopieren-status link-kopieren-fehler" role="alert">
                    <FormattedMessage id="Link_kopieren_Fehler" />
                </span>
            )}
        </div>
    );
}

export default LinkKopieren;
